/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var SeriesRenderManager = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(SeriesRenderManager, _super);
    function SeriesRenderManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ag = null;
        _this.ah = null;
        _this.m = 0;
        _this.am = null;
        _this.ao = 0;
        _this.k = 0;
        _this.l = 0;
        _this.j = 0;
        _this.i = 0;
        _this.au = 0;
        _this.aq = 0;
        _this.ap = 0;
        _this.ak = null;
        _this.al = null;
        _this.t = 0;
        _this.an = null;
        _this.ar = 0;
        _this.r = 0;
        _this.s = 0;
        _this.q = 0;
        _this.p = 0;
        _this.av = 0;
        _this.at = 0;
        _this.as = 0;
        _this.ai = null;
        _this.aj = null;
        _this.n = 0;
        _this.o = 0;
        _this.f = false;
        _this.e = false;
        _this.ae = null;
        _this.af = null;
        _this.g = 0;
        _this.h = 0;
        _this.b = null;
        _this.d = null;
        return _this;
    }
    SeriesRenderManager.prototype.w = function (a, b, c) {
        this.e = false;
        this.ai = a.pc();
        this.aj = a.pd();
        this.n = 1;
        this.o = a.f6();
        this.ae = this.ai;
        this.af = this.aj;
        this.g = this.n;
        this.h = this.o;
        var d = b;
        this.d = null;
        if (d) {
            this.d = this.c();
            this.d.j = 0;
            this.d.l = 0;
            this.d.m = 0;
            if (a.ce != null && a.bl != 1) {
                this.d.j = a.ce.a7.maxMarkerHighlightingProgress;
                this.d.l = a.ce.a7.sumMarkerHighlightingProgress;
                this.d.m = a.ce.a7.totalHighlightingProgress;
            }
            this.d.a = c;
        }
    };
    SeriesRenderManager.prototype.c = function () {
        return null;
    };
    SeriesRenderManager.prototype.x = function (a, b, c) {
        this.f = false;
        this.ak = a.o5;
        this.al = a.o8;
        this.t = a.fy;
        this.an = a.pi;
        this.ar = a.pj;
        this.r = 0;
        this.s = 0;
        this.q = 1;
        this.p = a.gw;
        this.at = a.pk;
        this.as = a.pk;
        this.av = a.pl;
        this.ag = this.ak;
        this.ah = this.al;
        this.m = this.t;
        this.am = this.an;
        this.ao = this.ar;
        this.k = this.r;
        this.l = this.s;
        this.j = this.q;
        this.i = this.p;
        this.aq = this.at;
        this.ap = this.as;
        this.au = this.av;
        var d = b;
        this.b = null;
        if (d) {
            this.b = this.a();
            this.b.j = 0;
            this.b.l = 0;
            this.b.m = 0;
            if (a.ce != null && a.bl != 1) {
                this.b.j = a.ce.a7.maxHighlightingProgress;
                this.b.l = a.ce.a7.sumHighlightingProgress;
                this.b.m = a.ce.a7.totalHighlightingProgress;
            }
            this.b.a = c;
        }
    };
    SeriesRenderManager.prototype.a = function () {
        return null;
    };
    SeriesRenderManager.prototype.ad = function (a, b, c, d, e) {
        var f = this.ag;
        if (e) {
            f = this.ah;
        }
        if (c) {
            a._fill = f;
        }
        else {
            if (b) {
                a._stroke = f;
            }
            else {
                a._fill = f;
                a._stroke = this.ah;
            }
            a.ad = this.m;
            a.ai = this.am;
            a.aj = this.ao;
            if (d) {
                a.ac = this.i;
                a.am = this.au;
                a.al = this.aq;
                a.ak = this.ap;
            }
        }
        a._opacity = this.j;
    };
    SeriesRenderManager.prototype.ac = function (a, b) {
        a._opacity = this.g;
        b.itemBrush = this.ae;
        b.thickness = this.h;
        b.actualItemBrush = b.itemBrush;
        b.outline = this.af;
    };
    SeriesRenderManager.prototype.u = function (a, b, c, d, e, f) {
        if (a.bl == 1) {
            return;
        }
        this.j = a.a7.a$i(a, b, this.j, c, d, e, f);
        this.ag = a.a7.a$ak(a, b, this.ag);
        this.ah = a.a7.a$ak(a, b, this.ah);
    };
    SeriesRenderManager.prototype.v = function (a, b, c, d, e) {
        if (a.bl == 1) {
            return;
        }
        this.g = a.a7.a$i(a, b, this.g, c, d, e, false);
        this.ae = a.a7.a$ak(a, b, this.ae);
        this.af = a.a7.a$ak(a, b, this.af);
    };
    SeriesRenderManager.prototype.ab = function (a) {
        this.ag = this.ak;
        this.ah = this.al;
        this.m = this.t;
        this.am = this.an;
        this.ao = this.ar;
        this.k = this.r;
        this.l = this.s;
        this.j = this.q;
        var b = this.b;
        b.p = this.ag;
        b.q = this.ah;
        b.t = this.m;
        b.u = this.am;
        b.v = this.ao;
        b.r = this.k;
        b.s = this.l;
        b.k = this.j;
        b.e = this.f;
        b.i = a;
        b.d = false;
    };
    SeriesRenderManager.prototype.z = function (a, b, c, d, e) {
        var f = this.b;
        this.ag = f.p;
        this.ah = f.q;
        this.m = f.t;
        this.am = f.u;
        this.ao = f.v;
        this.k = f.r;
        this.l = f.s;
        this.j = f.k;
        if (d && !f.d && !c) {
            this.u(a, b, f.m, f.m, f.i, e);
        }
    };
    SeriesRenderManager.prototype.aa = function (a) {
        this.ae = this.ai;
        this.af = this.aj;
        this.g = this.n;
        var b = this.d;
        b.p = this.ae;
        b.q = this.af;
        b.k = this.g;
        b.e = this.e;
        b.i = a;
        b.d = false;
    };
    SeriesRenderManager.prototype.y = function (a, b, c, d, e, f) {
        var g = this.d;
        this.ae = g.p;
        this.af = g.q;
        this.g = g.k;
        if (d && !g.d && !c) {
            this.v(a, b, e, f, g.i);
        }
    };
    SeriesRenderManager.$t = markType(SeriesRenderManager, 'SeriesRenderManager');
    return SeriesRenderManager;
}(Base));
export { SeriesRenderManager };
